import axios from "axios";
import { AES, enc } from 'crypto-js';
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import { useNavigate, useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { ResizeObserver } from 'resize-observer';
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import { logout, reset } from "../../../../features/auth/authSlice";
import userTypeConsts from "../../../../constants/userTypeConsts.js";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { setVendorInvoiceData } from "../../../../features/vendor/vendorInvoiceSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import { useGetVendors } from "../../../TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import userCategory from "../../../../constants/userCategory.js";

const VendorsInvoicesModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [vendorDropdownOpen, setVendorDropdownOpen] = useState(false);
  const [vendorSearchTerm, setVendorSearchTerm] = useState('');
  const [vendorSelectedId, setVendorSelectedId] = useState('');
  const vendorDropdownRef = useRef(null);
  const dropdownListRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState({ message: null, field: null });
  const { appSettings } = useSelector((state) => state.appSettings);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  let token = null;
  const user = useSelector(
    (state) => state.auth.user
  )
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const handleSelect = (ranges) => {
    setDateRange(ranges);
    setErrorMessage({ message: null, field: null });
  };
  const SUPER_ADMIN = 1;
  const ADMIN = 2;
  const ref = useRef(null);
  let resizeObserver = null;

  // const { data: userId = [], isLoading: isUserLoading } = useUserById(token);
  const { data: vendors = [], isLoading: vendorLoading, refetch: refetchVendorProfiles, isError: vendorError } = useGetVendors(token);

  const handleToggleVendorDropdown = () => {
    setVendorSearchTerm('');
    setVendorDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleVendorSearchInputChange = (e) => {
    setVendorSearchTerm(e.target.value);
  };

  const filteredVendors = vendors.filter((vendor) => {
    const fullName = vendor.vendor_name
      ? `${vendor.vendor_name}`
      : `${vendor.vendor_legalentity_name}`;
    return fullName.toLowerCase().includes(vendorSearchTerm.toLowerCase());
  });

  const handleSelectVendor = (selectedVendorId) => {
    setErrorMessage({ message: null, field: null });
    setVendorSelectedId(selectedVendorId);
    setVendorSearchTerm('');
    setVendorDropdownOpen(false);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideVendorDropdown = vendorDropdownRef.current && vendorDropdownRef.current.contains(event.target);
    if (!isClickInsideVendorDropdown) {
      setVendorDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  useEffect(() => {
    // Get the selected item
    const selectedItem = document.querySelector('.selected-item');
    // Get the container element
    const dropdownListContainer = dropdownListRef.current;

    // Scroll to the selected item and center it in the view
    if (selectedItem && dropdownListContainer) {
      selectedItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [vendorDropdownOpen, vendorSearchTerm, filteredVendors, vendorSelectedId]);

  useEffect(() => {
    // Create a new ResizeObserver instance
    resizeObserver = new ResizeObserver(entries => {
      // Handle resize event
    });

    if (ref.current) {
      // Observe the target element
      resizeObserver.observe(ref.current);
    }

    // Cleanup function
    return () => {
      if (resizeObserver) {
        // Disconnect the observer when component unmounts
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
  }, []);

  const vendorInvoiceSubmit = async () => {
    var autoData = [];

    if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
      if (vendorSelectedId === "" || Object.keys(vendorSelectedId).length === 0) {
        toast.error("Please select vendor", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setErrorMessage({ message: "Please Select different date", field: "both" })
        return;
      } else {
      }
    }
    if (!dateRange || !Array.isArray(dateRange) || dateRange.length !== 2) {
      toast.error("Please select date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else if (dateRange[0] === dateRange[1]) {
      toast.error("Please select date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else if (dateRange[0].getTime() === dateRange[1].getTime()) {
      toast.error("Please select different date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else {
      // Convert Date objects to ISO strings for Redux serialization
      const serializedDateRange = dateRange.map(date => date instanceof Date ? date.toISOString() : date);
      autoData.push(serializedDateRange);
      if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
        autoData.push(vendorSelectedId);
      } else {
        if (user && (user.userCategory === userCategory.Vendor) && user.venId) {
          autoData.push(user.venId);
        } else {
          // console.log(user);
          toast.error("Please logout and login to create a invoice", {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setErrorMessage({ message: "Please Select different date", field: "both" })
          return;
        }
      }
      await dispatch(setVendorInvoiceData(autoData));
      navigate(`/vendor/invoices/create/${encodeURIComponent(AES.encrypt(vendorSelectedId, 'encryptionKey').toString().replace(/\//g, '%2F'))}`);
    }
  };

  return (
    <div className="invoice-modal" ref={ref}>
      <h2 className="invoice-modal-main-head">Create Invoice</h2>
      {(user && (user.userCategory !== userCategory.Vendor)) && (
        <div className="form-group-1modal userseloutter-1">
          {vendorLoading ?
            null :
            <label htmlFor="user-select">Vendors *</label>
          }
          {vendorLoading ?
            <div className="outter-load-table">
              <ThreeDots
                height="37"
                width="39"
                radius="9"
                color="#6479f9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div> :
            <div ref={vendorDropdownRef} className={errorMessage && errorMessage.field === 'both' ? "select-modal-mainM error custom-dropdown-user-new-outer" : "select-modal-mainM custom-dropdown-user-new-outer"}>
              <span
                id="user-select"
                onClick={handleToggleVendorDropdown}
                className="custom-dropdown-user-new"
              >
                <span>
                  {vendorSelectedId
                    ? vendors.find((item) => item._id === vendorSelectedId)?.vendor_name
                    : 'Select Vendor'}
                </span>
                <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="dropdown-chevron-icon" aria-hidden="true">
                  <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && vendorDropdownOpen && (
                <div className="custom-dropdown-new" ref={dropdownListRef}>
                  <input
                    type="text"
                    className="search-bar"
                    placeholder="Search..."
                    value={vendorSearchTerm}
                    onChange={handleVendorSearchInputChange}
                  />
                  <ul className="vendor-list">
                    {filteredVendors.length > 0 &&
                      filteredVendors
                        .slice()
                        .sort((a, b) =>
                          a.vendor_name.toLowerCase().localeCompare(b.vendor_name.toLowerCase())
                        )
                        .map((vendor) => (
                          <li key={vendor._id} onClick={() => handleSelectVendor(vendor._id)} className={vendorSelectedId === vendor._id ? 'selected-item' : ''}>
                            {vendor.vendor_name && `${vendor.vendor_name}`}
                          </li>
                        ))
                    }
                  </ul>
                </div>
              )
              }
            </div>
          }
        </div>
      )}

      <div className="form-group-1modal range-picinmodal-1">
        <label htmlFor="date-range">Date Range *</label>

        <div className="date-picker-outer date-picker-outer-all">
          <div className="custom-picker-icon custom-picker-icon-all">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 14 14"
              fill="currentColor"
              aria-hidden="true"
              focusable="false"
              className="rs-picker-toggle-caret rs-icon"
              aria-label="calendar"
              data-category="legacy"
            >
              <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
            </svg>
          </div>
          <div className="custoom-icon-calender custoom-icon-calender-all">
            <DateRangePicker
              className={errorMessage && errorMessage.field === 'both' ? "errorDate" : ""}
              id="date-range"
              format="dd/MM/yyyy"
              placeholder="Select a date range"
              value={dateRange}
              onChange={handleSelect}
              placement="auto"
              isoWeek={appSettings.weekStartDay === 'Monday'}
            />
          </div>
        </div>

      </div>
      <div className="form-group-1modal submittseloutter-1">
        <button className="create-button modalsubmitbtn-1" onClick={vendorInvoiceSubmit}>
          Create Invoice
        </button>
      </div>
    </div>
  );
};

export default VendorsInvoicesModal;